import axios from "axios";
import clientConfig from "../client/config/clientConfig";

// ⚙️ Crée une instance axios avec baseURL injectée à la génération
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// ⚠️ Garde : prévenir en dev si REACT_APP_API_URL manquant
if (process.env.NODE_ENV === "development" && !process.env.REACT_APP_API_URL) {
  console.warn(
    "⚠️ Variable d'environnement REACT_APP_API_URL manquante — vérifie l'injection à la génération."
  );
}

// 🔑 Injection automatique du clientKey
try {
  // 1️⃣ D’abord dans le localStorage (client sélectionné manuellement)
  let clientKey = localStorage.getItem("selectedClient");

  // 2️⃣ Sinon depuis la config du client (clientConfig.js)
  if (!clientKey && clientConfig?.clientKey) {
    clientKey = clientConfig.clientKey;
  }

  // 3️⃣ Si on a une clé valide → on l’injecte dans les headers
  if (clientKey) {
    api.defaults.headers.common["x-client-key"] = clientKey;

    // ✅ Log uniquement en mode développement
    if (process.env.NODE_ENV === "development") {
      console.log("✅ x-client-key appliqué :", clientKey);
    }
  } else {
    console.warn("⚠️ Aucun clientKey trouvé (ni localStorage, ni clientConfig)");
  }
} catch (e) {
  console.error("❌ Erreur lors de l'application du clientKey :", e.message);
}

export default api;
